(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ut-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-filters')) {
  customElements.define('ut-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.section = this.closest('section[data-section-id]');
      this.nav = this.closest('ut-collection-navigation');
      this.grid = this.section?.querySelector('[data-products-grid]');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.opener = this.querySelector('[data-ut-filter-open]');
      if (!this.grid) return;
      this.labels=JSON.parse(this.querySelector('[data-ut-discovery-labels]').textContent);
      this.opener.addEventListener('click', () => {
        this.prepareGroups();
        this.syncSizes();
        this.oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
      }, {signal});
      this.querySelector('[data-ut-filter-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {if (event.target === this.dialog) this.dialog.close();}, {signal});
      this.dialog.addEventListener('close', () => {document.body.style.overflow = this.oldOverflow || '';this.opener.setAttribute('aria-expanded','false');}, {signal});
      this.form.addEventListener('change', () => this.syncStockRequirement(), {signal});
      this.form.addEventListener('submit', event => {event.preventDefault();this.applyForm();}, {signal});
      this.querySelector('[data-ut-filter-clear]').addEventListener('click', () => {
        this.form.querySelectorAll('input').forEach(input => {if(input.type === 'checkbox') input.checked=false;else input.value='';});
        this.applyForm();
      }, {signal});
      this.grid.addEventListener('click', event => {
        const more = event.target.closest('[data-ut-size-more]');
        if(more) {event.preventDefault();this.showCards(this.visibleCards + 24);}
      }, {signal});
      window.addEventListener('popstate', () => this.update(new URL(location.href), false), {signal});
      this.nav.querySelector('[data-ut-filter-chips]').addEventListener('click',event=>{
        const button=event.target.closest('[data-remove-key]');if(!button)return;
        const url=new URL(location.href),key=button.dataset.removeKey,value=button.dataset.removeValue;
        const remaining=url.searchParams.getAll(key).filter(v=>v!==value);url.searchParams.delete(key);remaining.forEach(v=>url.searchParams.append(key,v));
        if(key==='filter.v.price.gte'){url.searchParams.delete('filter.v.price.lte');}
        this.update(url,true);
      },{signal});
      if(this.hasAttribute('data-ut-search-mode'))this.section.querySelector('.ut-search-form')?.addEventListener('submit',event=>{
        event.preventDefault();
        const url=new URL(location.href);
        for(const key of [...url.searchParams.keys()])if(key.startsWith('ut_')||key.startsWith('filter.')||key==='page'||key==='sort_by')url.searchParams.delete(key);
        url.searchParams.set('q',event.currentTarget.querySelector('[name="q"]').value.trim());url.searchParams.set('type','product');
        this.update(url,true);
      },{signal});
      this.syncSizes();
      this.updateBadge();
      if(this.hasAttribute('data-ut-search-mode') || [...new URL(location.href).searchParams.keys()].some(k=>k.startsWith('ut_')||k.startsWith('filter.'))) this.update(new URL(location.href), false);
    }
    disconnectedCallback() {this.controller?.abort();this.request?.abort();this.controller=null;if(this.dialog?.open)document.body.style.overflow=this.oldOverflow||'';}
    syncSizes() {
      const params=new URL(location.href).searchParams;
      this.form.querySelectorAll('input').forEach(input=>{if(input.type==='checkbox')input.checked=params.getAll(input.name).includes(input.value);else input.value=params.get(input.name)||'';});
      const sizes = params.getAll('ut_ring_size');
      this.form.querySelectorAll('[name="ut_ring_size"]').forEach(input => input.checked=sizes.includes(input.value));
      const stock=this.form.querySelector('[data-ut-stock-only]');
      if(stock)stock.checked=new URL(location.href).searchParams.get('filter.v.availability')==='1'||sizes.length>0;
      this.syncStockRequirement();
    }
    syncStockRequirement() {
      const required=Boolean(this.form.querySelector('[name="ut_ring_size"]:checked'));
      const stock=this.form.querySelector('[data-ut-stock-only]');
      if(stock){if(required)stock.checked=true;stock.disabled=required;}
    }
    updateBadge() {
      const params = new URL(location.href).searchParams;
      let count=0;
      for(const [key,value] of params) if(value && (key.startsWith('filter.') || key.startsWith('ut_')) && !key.startsWith('filter.v.price.')) count++;
      if(params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) count++;
      this.renderChips(params);
      const badge=this.querySelector('[data-ut-filter-count]');badge.textContent=`(${count})`;badge.hidden=count===0;this.opener.dataset.active=String(count>0);
    }
    applyForm() {
      const url=new URL(location.href);
      for(const key of [...url.searchParams.keys()]) if(key.startsWith('filter.')||key.startsWith('ut_')||key==='page')url.searchParams.delete(key);
      for(const [key,value] of new FormData(this.form)) if(value!=='')url.searchParams.append(key,value);
      if(url.searchParams.has('ut_ring_size'))url.searchParams.set('filter.v.availability','1');
      const min=this.form.querySelector('[name="filter.v.price.gte"]');
      const max=this.form.querySelector('[name="filter.v.price.lte"]');
      if(min&&max&&min.value&&max.value&&Number(min.value)>Number(max.value)) {
        url.searchParams.set('filter.v.price.gte',max.value);url.searchParams.set('filter.v.price.lte',min.value);
      }
      this.update(url,true);
    }
    async fetchDocument(url,signal) {
      const response=await fetch(url.toString(),{signal});if(!response.ok)throw new Error('Filter request failed');
      return new DOMParser().parseFromString(await response.text(),'text/html');
    }
    async catalog(url) {
      if(this.hasAttribute('data-ut-search-mode') && window.UTProductSearch) return window.UTProductSearch.rank(await window.UTProductSearch.catalog(),url.searchParams.get('q')||'');
      const endpoint=new URL(url);endpoint.searchParams.set('view','ut-size-results');
      for(const key of [...endpoint.searchParams.keys()])if(key.startsWith('ut_')||key.startsWith('filter.')||key==='page')endpoint.searchParams.delete(key);
      const cacheKey=endpoint.href;
      if(this.catalogKey===cacheKey&&this.catalogPromise)return this.catalogPromise;
      this.catalogKey=cacheKey;
      this.catalogPromise=(async()=>{
        endpoint.searchParams.set('page','1');let doc=await this.fetchDocument(endpoint,this.controller.signal);
        const marker=doc.querySelector('[data-ut-size-pages]');if(!marker)throw new Error('Discovery unavailable');
        const pages=Math.max(1,Number(marker.dataset.utSizePages)),records=[];
        for(let page=1;page<=pages;page++){
          if(page>1){endpoint.searchParams.set('page',String(page));doc=await this.fetchDocument(endpoint,this.controller.signal);}
          for(const template of doc.querySelectorAll('template[data-ut-size-card]')){
            records.push({template,handle:template.dataset.productHandle,metal:template.dataset.metal,...JSON.parse(template.content.querySelector('[data-ut-discovery]').textContent),variants:JSON.parse(template.content.querySelector('[data-ut-size-variants]').textContent)});
          }
        }
        return records;
      })().catch(error=>{this.catalogPromise=null;throw error;});
      return this.catalogPromise;
    }
    buildGroups(records) {
      const host=this.querySelector('[data-ut-discovery-groups]');host.replaceChildren();
      for(const [key,field,title,labels] of [['ut_style','styles','style',this.labels.styles],['ut_design','designs','design',this.labels.designs],['ut_engravable','engravable','personalisation',{'1':this.labels.engravable}]]){
        const values=Object.keys(labels).filter(value=>records.some(r=>field==='engravable'?r.engravable:r[field].includes(value)));
        if(!values.length)continue;
        const group=document.createElement('details');group.className='ut-filter-group';
        const summary=document.createElement('summary');summary.textContent=this.labels[title];group.append(summary);
        const options=document.createElement('div');options.className='ut-discovery-options';
        for(const value of values){
          const label=document.createElement('label'),input=document.createElement('input'),text=document.createElement('span'),count=document.createElement('small');
          input.type='checkbox';input.name=key;input.value=value;text.textContent=labels[value];
          count.textContent=records.filter(r=>field==='engravable'?r.engravable:r[field].includes(value)).length;
          label.append(input,text,count);options.append(label);
        }
        group.append(options);host.append(group);
      }
      const sizeGroup=this.form.querySelector('.ut-ring-size-filter')?.closest('details');
      if(sizeGroup)sizeGroup.hidden=!records.some(r=>r.variants.some(v=>v.size!==null));
      this.syncSizes();
      this.form.querySelectorAll('details').forEach(group=>{if(group.querySelector('input:checked'))group.open=true;});
    }
    async prepareGroups(){
      const status=this.querySelector('[data-ut-discovery-status]');status.hidden=false;
      this.form.querySelector('[type="submit"]').disabled=true;
      try{this.buildGroups(await this.catalog(new URL(location.href)));}
      catch(error){if(error.name!=='AbortError'){const message=this.querySelector('[data-ut-filter-error]');message.textContent=this.dataset.error;message.hidden=false;}}
      finally{status.hidden=true;this.form.querySelector('[type="submit"]').disabled=false;}
    }
    matchingVariant(record,params){
      const metals=params.getAll('ut_metal');
      if(metals.length&&!metals.some(m=>String(record.metal).split(' ').includes(m)))return null;
      const styles=params.getAll('ut_style'),designs=params.getAll('ut_design'),sizes=params.getAll('ut_ring_size');
      if(styles.length&&!styles.some(s=>record.styles.includes(s)))return null;
      if(designs.length&&!designs.some(s=>record.designs.includes(s)))return null;
      if(params.has('ut_engravable')&&!record.engravable)return null;
      const min=Number(params.get('filter.v.price.gte')||0),max=Number(params.get('filter.v.price.lte')||Infinity);
      return record.variants.find(v=>v.primary&&(!sizes.length||sizes.includes(String(v.size).replace(/^US\s*/i,'').trim()))&&(!(sizes.length||params.get('filter.v.availability')==='1')||v.stock)&&v.price>=min&&v.price<=max);
    }
    filterCards(records,url){
      const cards=[];
      for(const record of records){
        const match=this.matchingVariant(record,url.searchParams);if(!match)continue;
        const card=record.template.content.querySelector('[data-product-grid-item]').cloneNode(true);
        if(url.searchParams.has('ut_ring_size'))card.querySelectorAll('a[href]').forEach(link=>{const target=new URL(link.getAttribute('href'),url);if(target.pathname.endsWith('/products/'+record.handle)){target.searchParams.set('variant',match.id);link.href=target.href;}});
        card.dataset.utMatchedPrice=String(match.price);cards.push(card);
      }
      const sort=url.searchParams.get('sort_by');
      if(this.hasAttribute('data-ut-search-mode') && (sort==='price-ascending'||sort==='price-descending'))cards.sort((a,b)=>(Number(a.dataset.utMatchedPrice)-Number(b.dataset.utMatchedPrice))*(sort==='price-ascending'?1:-1));
      return cards;
    }
    renderChips(params){
      const host=this.nav.querySelector('[data-ut-filter-chips]');host.replaceChildren();
      const add=(key,value,label)=>{const button=document.createElement('button');button.type='button';button.dataset.removeKey=key;button.dataset.removeValue=value;button.textContent=label+' ×';button.setAttribute('aria-label',this.labels.remove+' '+label);host.append(button);};
      const surfaced=(key,value)=>[...this.nav.querySelectorAll('[data-ut-discovery-key]')].some(button=>button.dataset.utDiscoveryKey===key&&button.dataset.utDiscoveryValue===value&&button.offsetParent!==null);
      for(const value of params.getAll('ut_metal'))add('ut_metal',value,this.labels.metals[value]||value);
      for(const value of params.getAll('ut_style'))add('ut_style',value,this.labels.styles[value]||value);
      for(const value of params.getAll('ut_design'))if(!surfaced('ut_design',value))add('ut_design',value,this.labels.designs[value]||value);
      if(params.has('ut_engravable')&&!surfaced('ut_engravable','1'))add('ut_engravable','1',this.labels.engravable);
      for(const value of params.getAll('ut_ring_size'))add('ut_ring_size',value,this.labels.size+' '+value);
      if(params.get('filter.v.availability')==='1'&&!params.has('ut_ring_size'))add('filter.v.availability','1',this.labels.stock);
      if(params.has('filter.v.price.gte')||params.has('filter.v.price.lte'))add('filter.v.price.gte',params.get('filter.v.price.gte')||'',this.labels.price+': '+(params.get('filter.v.price.gte')||'0')+'–'+(params.get('filter.v.price.lte')||'∞'));
      host.hidden=!host.children.length;
    }
    showCards(limit) {
      this.visibleCards=limit;
      this.grid.replaceChildren(...this.cards.slice(0,limit).map(card=>card.cloneNode(true)));
      if(!this.cards.length){const empty=document.createElement('p');empty.className='no-results';empty.textContent=this.dataset.empty;this.grid.append(empty);}
      if(limit<this.cards.length){const holder=document.createElement('div');holder.className='ut-size-load-more';const button=document.createElement('button');button.type='button';button.dataset.utSizeMore='';button.textContent=this.dataset.more;holder.append(button);this.grid.append(holder);}
    }
    async update(url,push) {
      this.request?.abort();this.request=new AbortController();const signal=this.request.signal;
      this.querySelector('[data-ut-filter-error]').hidden=true;
      this.querySelectorAll('.ut-filter-actions button').forEach(button=>button.disabled=true);
      this.querySelector('[data-ut-filter-loading]').hidden=false;this.grid.setAttribute('aria-busy','true');
      if(this.hasAttribute('data-ut-search-mode'))this.nav.querySelector('.ut-collection-result-count').textContent=this.dataset.searchLoading;
      try {
        const records=await this.catalog(url);if(signal.aborted)return;
        const cards=this.filterCards(records,url);
        if(push)history.pushState(null,'',url);
        this.cards=cards;this.showCards(24);this.buildGroups(records);
        this.nav.querySelector('.ut-collection-result-count').textContent=this.nav.dataset.countLabel.replace('[count]',cards.length);
        if(this.hasAttribute('data-ut-search-mode')){
          const query=url.searchParams.get('q')||'';
          document.title=query+' — '+cards.length+' — '+document.title.split(' – ').pop().split(' — ').pop();
          this.section.querySelector('.ut-search-form [name="q"]').value=query;
          const heading=this.section.querySelector('.ut-search-heading strong');if(heading)heading.textContent=query;
          const sort=this.section.querySelector('ut-search-sort select');if(sort)sort.value=url.searchParams.get('sort_by')||'relevance';
        }
        this.syncSizes();this.updateBadge();
        this.dispatchEvent(new CustomEvent('ut:filters-updated',{bubbles:true}));
        if(this.dialog.open)this.dialog.close();
      } catch(error) {
        if(error.name!=='AbortError'){console.warn('Collection filter update failed:',error);const message=this.querySelector('[data-ut-filter-error]');message.textContent=this.dataset.error;message.hidden=false;if(!this.dialog.open){this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.opener.setAttribute('aria-expanded','true');}}
      } finally {
        if(!signal.aborted){this.querySelectorAll('.ut-filter-actions button').forEach(button=>button.disabled=false);this.querySelector('[data-ut-filter-loading]').hidden=true;this.grid.removeAttribute('aria-busy');}
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control-before-metal-underline-fix"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control-before-mobile-declutter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control-before-mobile-hierarchy-fix"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control-before-represent-mobile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-grid-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      const grid = this.section.querySelector('[data-products-grid]');
      if (grid) {
        this.imageObserver = new MutationObserver(() => this.updateImageSizes());
        this.imageObserver.observe(grid, {childList: true});
      }
      this.breakpoint = matchMedia('(max-width:767px)');
      this.breakpoint.addEventListener('change', () => this.updateImageSizes(), {signal: this.controller.signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
      this.updateImageSizes();
    }
    updateImageSizes() {
      const mobile = matchMedia('(max-width:767px)').matches;
      const density = this.section.dataset.utDensity || 'medium';
      const columns = density === 'large' ? (mobile ? 1 : 2) : density === 'small' ? (mobile ? 3 : 6) : (mobile ? 2 : 4);
      const sizes = `${100 / columns}vw`;
      this.section.querySelectorAll('img[data-ut-card-image]').forEach(image => {
        if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
      });
    }
    disconnectedCallback() { this.imageObserver?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation-before-live-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.syncDesignShortcuts();
      this.addEventListener('ut:filters-updated', () => {
        this.syncLinks();
        this.syncDesignShortcuts();
      });
      this.querySelector('[data-ut-design-shortcuts]')?.addEventListener('click', event => {
        const button = event.target.closest('[data-ut-discovery-key]');
        if (!button) return;
        const url = new URL(window.location.href);
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const isActive = button.getAttribute('aria-pressed') === 'true';

        url.searchParams.delete('ut_design');
        url.searchParams.delete('ut_engravable');
        url.searchParams.delete('page');

        if (!isActive) url.searchParams.set(key, value);

        const filters = this.querySelector('ut-collection-filters');
        if (filters && typeof filters.update === 'function') {
          filters.update(url, true);
        } else {
          window.location.href = url.href;
        }
      });
    }
    syncDesignShortcuts() {
      const params = new URL(window.location.href).searchParams;
      const selectedDesigns = params.getAll('ut_design');
      const engravable = params.has('ut_engravable');
      this.querySelectorAll('[data-ut-discovery-key]').forEach(button => {
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const active = key === 'ut_engravable' ? engravable : selectedDesigns.includes(value);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const active = this.querySelector('[data-ut-discovery-key][aria-pressed="true"]');
      if (active) active.scrollIntoView({block:'nearest', inline:'nearest'});
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (link.dataset.utGroup === 'ut-category-') {
          for (const key of [...target.searchParams.keys()]) {
            if (key.startsWith('ut_') || key.startsWith('filter.') || key === 'sort_by') target.searchParams.delete(key);
          }
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation-before-represent-type"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.syncDesignShortcuts();
      this.addEventListener('ut:filters-updated', () => {
        this.syncLinks();
        this.syncDesignShortcuts();
      });
      this.querySelector('[data-ut-design-shortcuts]')?.addEventListener('click', event => {
        const button = event.target.closest('[data-ut-discovery-key]');
        if (!button) return;
        const url = new URL(window.location.href);
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const isActive = button.getAttribute('aria-pressed') === 'true';

        url.searchParams.delete('ut_design');
        url.searchParams.delete('ut_engravable');
        url.searchParams.delete('page');

        if (!isActive) url.searchParams.set(key, value);

        const filters = this.querySelector('ut-collection-filters');
        if (filters && typeof filters.update === 'function') {
          filters.update(url, true);
        } else {
          window.location.href = url.href;
        }
      });
    }
    syncDesignShortcuts() {
      const params = new URL(window.location.href).searchParams;
      const selectedDesigns = params.getAll('ut_design');
      const engravable = params.has('ut_engravable');
      this.querySelectorAll('[data-ut-discovery-key]').forEach(button => {
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const active = key === 'ut_engravable' ? engravable : selectedDesigns.includes(value);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const active = this.querySelector('[data-ut-discovery-key][aria-pressed="true"]');
      if (active) active.scrollIntoView({block:'nearest', inline:'nearest'});
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (/\/collections\/(necklaces|chains|bracelets|earrings)(?:\/|$)/.test(target.pathname) || /ut-category-(necklaces|bracelets|earrings)/.test(target.pathname)) target.searchParams.delete('ut_ring_size');
        if (link.dataset.utGroup === 'ut-category-' || /ut-category-/.test(target.pathname) || /\/collections\/(rings|necklaces|chains|bracelets|earrings|all-products)(?:\/|$)/.test(target.pathname)) {
          const targetCategory = target.pathname.match(/ut-category-([^/+]+)/)?.[1] || target.pathname.split('/')[2];
          const currentCategory = current.pathname.match(/ut-category-([^/+]+)/)?.[1] || current.pathname.split('/')[2];
          if (targetCategory !== currentCategory) target.searchParams.delete('ut_style');
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation-before-small-reference-type"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.syncDesignShortcuts();
      this.addEventListener('ut:filters-updated', () => {
        this.syncLinks();
        this.syncDesignShortcuts();
      });
      this.querySelector('[data-ut-design-shortcuts]')?.addEventListener('click', event => {
        const button = event.target.closest('[data-ut-discovery-key]');
        if (!button) return;
        const url = new URL(window.location.href);
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const isActive = button.getAttribute('aria-pressed') === 'true';

        url.searchParams.delete('ut_design');
        url.searchParams.delete('ut_engravable');
        url.searchParams.delete('page');

        if (!isActive) url.searchParams.set(key, value);

        const filters = this.querySelector('ut-collection-filters');
        if (filters && typeof filters.update === 'function') {
          filters.update(url, true);
        } else {
          window.location.href = url.href;
        }
      });
    }
    syncDesignShortcuts() {
      const params = new URL(window.location.href).searchParams;
      const selectedDesigns = params.getAll('ut_design');
      const engravable = params.has('ut_engravable');
      this.querySelectorAll('[data-ut-discovery-key]').forEach(button => {
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const active = key === 'ut_engravable' ? engravable : selectedDesigns.includes(value);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const active = this.querySelector('[data-ut-discovery-key][aria-pressed="true"]');
      if (active) active.scrollIntoView({block:'nearest', inline:'nearest'});
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (/\/collections\/(necklaces|chains|bracelets|earrings)(?:\/|$)/.test(target.pathname) || /ut-category-(necklaces|bracelets|earrings)/.test(target.pathname)) target.searchParams.delete('ut_ring_size');
        if (link.dataset.utGroup === 'ut-category-' || /ut-category-/.test(target.pathname) || /\/collections\/(rings|necklaces|chains|bracelets|earrings|all-products)(?:\/|$)/.test(target.pathname)) {
          const targetCategory = target.pathname.match(/ut-category-([^/+]+)/)?.[1] || target.pathname.split('/')[2];
          const currentCategory = current.pathname.match(/ut-category-([^/+]+)/)?.[1] || current.pathname.split('/')[2];
          if (targetCategory !== currentCategory) target.searchParams.delete('ut_style');
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.addEventListener('ut:filters-updated', () => this.syncLinks());
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (link.dataset.utGroup === 'ut-category-') {
          for (const key of [...target.searchParams.keys()]) {
            if (key.startsWith('ut_') || key.startsWith('filter.') || key === 'sort_by') target.searchParams.delete(key);
          }
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-overall-before-ut-collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-navigation')) {
  customElements.define('ut-collection-navigation', class extends HTMLElement {
    connectedCallback() {
      this.syncLinks();
      this.syncDesignShortcuts();
      this.addEventListener('ut:filters-updated', () => {
        this.syncLinks();
        this.syncDesignShortcuts();
      });
      this.querySelector('[data-ut-design-shortcuts]')?.addEventListener('click', event => {
        const button = event.target.closest('[data-ut-discovery-key]');
        if (!button) return;
        const url = new URL(window.location.href);
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const isActive = button.getAttribute('aria-pressed') === 'true';

        url.searchParams.delete('ut_design');
        url.searchParams.delete('ut_engravable');
        url.searchParams.delete('page');

        if (!isActive) url.searchParams.set(key, value);

        const filters = this.querySelector('ut-collection-filters');
        if (filters && typeof filters.update === 'function') {
          filters.update(url, true);
        } else {
          window.location.href = url.href;
        }
      });
    }
    syncDesignShortcuts() {
      const params = new URL(window.location.href).searchParams;
      const selectedDesigns = params.getAll('ut_design');
      const engravable = params.has('ut_engravable');
      this.querySelectorAll('[data-ut-discovery-key]').forEach(button => {
        const key = button.dataset.utDiscoveryKey;
        const value = button.dataset.utDiscoveryValue;
        const active = key === 'ut_engravable' ? engravable : selectedDesigns.includes(value);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const active = this.querySelector('[data-ut-discovery-key][aria-pressed="true"]');
      if (active) active.scrollIntoView({block:'nearest', inline:'nearest'});
    }
    syncLinks() {
      const current = new URL(window.location.href);
      this.querySelectorAll('a[data-ut-filter-link]').forEach(link => {
        if (!link.dataset.utBaseHref) link.dataset.utBaseHref = link.href;
        const target = new URL(link.dataset.utBaseHref, current.origin);
        target.search = ''; 
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') {
            target.searchParams.delete(key);
          }
        }
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') target.searchParams.append(key, value);
        }
        if (/\/collections\/(necklaces|chains|bracelets|earrings)(?:\/|$)/.test(target.pathname) || /ut-category-(necklaces|bracelets|earrings)/.test(target.pathname)) target.searchParams.delete('ut_ring_size');
        if (link.dataset.utGroup === 'ut-category-' || /ut-category-/.test(target.pathname) || /\/collections\/(rings|necklaces|chains|bracelets|earrings|all-products)(?:\/|$)/.test(target.pathname)) {
          const targetCategory = target.pathname.match(/ut-category-([^/+]+)/)?.[1] || target.pathname.split('/')[2];
          const currentCategory = current.pathname.match(/ut-category-([^/+]+)/)?.[1] || current.pathname.split('/')[2];
          if (targetCategory !== currentCategory) target.searchParams.delete('ut_style');
        }
        link.href = target.href;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-perf3-backup-snippets-ut-collection-grid-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-collection-grid-control')) {
  customElements.define('ut-collection-grid-control', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.section = this.closest('section[data-section-id]');
      if (!this.section) return;
      const valid = value => ['large', 'medium', 'small'].includes(value);
      let saved = 'medium';
      try { const value = sessionStorage.getItem('ut-collection-density'); if (valid(value)) saved = value; } catch {}
      this.applyDensity(saved);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-density]');
        if (!button || !this.contains(button) || !valid(button.dataset.density)) return;
        this.applyDensity(button.dataset.density);
        try { sessionStorage.setItem('ut-collection-density', button.dataset.density); } catch {}
      }, {signal: this.controller.signal});
    }
    applyDensity(value) {
      this.section.dataset.utDensity = value;
      this.querySelectorAll('button[data-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.density === value)));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-ring-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-ring-guide')) {
  customElements.define('ut-ring-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        if (this.visibilityObserver) this.visibilityObserver.observe(this.closest('.product-modal'), {attributes:true, attributeFilter:['style','class']});
        return;
      }
      this.ready = true;
      const modal = this.closest('.product-modal');
      if (modal) {
      const syncVisibility = () => modal.setAttribute('aria-hidden', String(getComputedStyle(modal).display === 'none'));
      this.visibilityObserver = new MutationObserver(syncVisibility);
      this.visibilityObserver.observe(modal, {attributes:true, attributeFilter:['style','class']});
      syncVisibility();
      }
      this.rows = Array.from(this.querySelectorAll('[data-guide-row]'));
      this.system = this.querySelector('[data-guide-system]');
      this.value = this.querySelector('[data-guide-value]');
      this.measurement = this.querySelector('[data-guide-measurement]');
      this.result = this.querySelector('[data-guide-result]');
      this.error = this.querySelector('[data-guide-error]');
      this.apply = this.querySelector('[data-guide-apply]');
      this.system.addEventListener('change', () => this.setupSystem());
      this.value.addEventListener('change', () => this.convert());
      this.measurement.addEventListener('input', () => this.convert());
      this.apply.addEventListener('click', () => this.applySize());
      this.querySelectorAll('[data-guide-pick]').forEach(button => button.addEventListener('click', () => {
        this.system.value = 'us';
        this.setupSystem();
        this.value.value = button.dataset.guidePick;
        this.convert();
        this.querySelector('.ut-guide-scroll').scrollTo({top: 0, behavior: 'auto'});
      }));
      this.querySelectorAll('[data-guide-tab]').forEach((button, index, tabs) => {
        button.addEventListener('click', () => this.showTab(button.dataset.guideTab));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.showTab(tabs[next].dataset.guideTab);
          tabs[next].focus();
        });
      });
      this.querySelectorAll('[data-guide-measure-with]').forEach(button => button.addEventListener('click', () => {
        this.showTab('convert');
        this.system.value = button.dataset.guideMeasureWith;
        this.setupSystem();
        this.measurement.focus();
      }));
      this.setupSystem();
    }
    disconnectedCallback() { this.visibilityObserver?.disconnect(); }
    showTab(name) {
      this.querySelectorAll('[data-guide-tab]').forEach(tab => {
        const selected = tab.dataset.guideTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-guide-panel]').forEach(panel => panel.hidden = panel.dataset.guidePanel !== name);
      this.querySelector('.ut-guide-scroll').scrollTop = 0;
    }
    setupSystem() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      this.querySelector('[data-guide-input-label]').hidden = !measurementMode;
      this.querySelector('[data-guide-select-label]').hidden = measurementMode;
      this.result.hidden = true;
      this.error.hidden = true;
      this.measurement.value = '';
      this.rows.forEach(row => delete row.dataset.selected);
      this.value.replaceChildren(new Option(this.dataset.prompt, ''));
      const start = system === 'us' ? 5 : system === 'uk' ? 9.5 : 49;
      const end = system === 'us' ? 12 : system === 'uk' ? 23.5 : 67;
      const step = system === 'eu' ? 1 : .5;
      if (measurementMode) return;
      for (let value = start; value <= end; value += step) {
        const label = system === 'uk' ? String.fromCharCode(65 + Math.floor(value)) + (value % 1 ? '½' : '') : String(value);
        this.value.add(new Option(label, String(value)));
      }
    }
    convert() {
      const system = this.system.value;
      const measurementMode = system === 'diameter' || system === 'circumference';
      const raw = measurementMode ? this.measurement.value.trim().replace(',', '.') : this.value.value;
      this.error.hidden = true;
      this.result.hidden = true;
      this.rows.forEach(row => delete row.dataset.selected);
      if (!raw) return;
      const value = Number(raw);
      const key = system === 'uk' ? 'ukNumber' : system;
      const valid = /^\d+(\.\d+)?$/.test(raw) && Number.isFinite(value);
      if (!valid || value <= 0) return this.showError(this.dataset.invalid);
      const first = Number(this.rows[0].dataset[key]);
      const last = Number(this.rows[this.rows.length - 1].dataset[key]);
      if (value < first || value > last) return this.showError(this.dataset.outside);
      const row = this.rows.reduce((best, candidate) => Math.abs(Number(candidate.dataset[key]) - value) <= Math.abs(Number(best.dataset[key]) - value) ? candidate : best);
      const exact = Math.abs(Number(row.dataset[key]) - value) < .01;
      this.selectedRow = row;
      row.dataset.selected = 'true';
      this.querySelector('[data-guide-match]').textContent = exact ? this.dataset.exact : this.dataset.approx;
      this.querySelector('[data-guide-output]').textContent = 'US ' + row.dataset.us;
      this.querySelector('[data-guide-detail]').textContent = 'UK ' + row.dataset.uk + ' · EU ' + row.dataset.eu + ' · ' + row.dataset.diameter + ' mm';
      const available = row.dataset.available === 'true';
      const offered = row.dataset.offered === 'true';
      this.apply.disabled = !available || !offered;
      this.apply.textContent = !offered ? this.dataset.notOffered : !available ? this.dataset.soldOut : this.dataset.apply.replace('[size]', row.dataset.us);
      this.result.hidden = false;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    applySize() {
      if (!this.selectedRow || this.apply.disabled) return;
      const form = this.closest('form');
      if (!form) return;
      const size = this.selectedRow.dataset.us;
      const input = Array.from(form.querySelectorAll('[data-single-option-selector]')).find(el => el.dataset.index === this.dataset.optionIndex && el.value === size);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      this.closest('.product-modal').querySelector('.product-modal__close').click();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ut-viewport-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ut-viewport-video')) {
  customElements.define('ut-viewport-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.slide = this.closest('[data-product-single-media-wrapper]');
      this.slide?.addEventListener('mediaVisible', () => this.refresh(), options);
      this.slide?.addEventListener('mediaHidden', () => this.video.pause(), options);
      document.addEventListener('visibilitychange', () => this.refresh(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inRange = entries[0].isIntersecting;
          this.refresh();
        }, {rootMargin: '160px 0px'});
        this.observer.observe(this);
      } else {
        this.inRange = true;
        this.refresh();
      }
    }
    refresh() {
      const hiddenSlide = matchMedia('(max-width: 767px)').matches && this.slide?.classList.contains('media--hidden');
      if (!this.inRange || document.hidden || hiddenSlide) {
        this.video.pause();
        return;
      }
      if (!this.loaded) {
        this.querySelectorAll('[data-ut-src]').forEach(node => {
          node.setAttribute('src', node.getAttribute('data-ut-src'));
          node.removeAttribute('data-ut-src');
        });
        this.video.load();
        this.loaded = true;
      }
      this.video.play().catch(() => {});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.video?.pause();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
